import React from "react";
import CodeEditor from "../components/CodeEditor";

const baseurl = "rizzapi.vercel.app/";

const GetByCategory = () => {
  return (
    <section id="category">
      <div className="endpoint">1.Category</div>
      Category :
      <div className="idea">
        Simply designate your desired category, and we will curate pick-up lines
        that suit your selection.
      </div>
      <ul className="disc">
        <li>romantic 😍</li>
        <li>funny 😂</li>
        <li>cheesy 🧀</li>
        <li>flirty 😉</li>
        <li>clever 🤓</li>
        <li>Complimentary 🍭</li>
      </ul>
      <div className="line"></div>
      Method: <span className="method">GET</span>
      <div className="dbline"></div>
      URL: <span className="method">{baseurl}category/:category</span>
      <div className="dbline"></div>
      Query Parameters
      <ul>
        <li>
          <span className="method">page </span>
          <div className="idea">
            (optional, default: 1) - The page number of results to retrieve.
          </div>
        </li>
        <li>
          <span className="method">perPage</span>
          <div className="idea">
            (optional, default: 20) - The number of responses to return per
            page.
          </div>
        </li>
      </ul>
      <br />
      <div className="line"></div>
      Example Request
      <CodeEditor>{`rizzapi.vercel.app/category/:Funny?page=1&perPage=2`}</CodeEditor>
      <br />
      Response:
      <br />
      <CodeEditor>{`[
  {
    "ratings": {
      "average": 0,
      "count": 0
    },
    "_id": "65147a8b63ef48d364f9fca2",
    "text": "I’m learning about important dates in history. Wanna be one of them?",
    "category": "Funny",
    "language": "English",
    "tags": [],
    "usageExamples": [],
    "dateCreated": "2023-09-27T18:55:07.262Z",
    "comments": [],
    "__v": 0
  }
]

`}</CodeEditor>
      <div className="line"></div>
    </section>
  );
};

export default GetByCategory;
